import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-cust-grp-langs',
  templateUrl: './cust-grp-langs.component.html',
  styleUrls: ['./cust-grp-langs.component.css']
})
export class CustGrpLangsComponent implements OnInit {
    custGrpId;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custGrpId = this.stateService.getStateParams()['custgrp_id'];
    }

    private async loadLanguages() {
        if (!!this.custGrpId) {
            this.inputListLanguages = await this.datatask.Post(1007, { custgrp_id: this.custGrpId });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(1008, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface InputLanguageItem {
    custgrp_id: number;
    custgrplang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}
